import { StyledAlert } from "App/global-style";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { coveragePriceDifference } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { AlertType } from "Components/Form/Alert";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { useFormikContext } from "formik";
import React from "react";
import { ChildPriceFormValues } from "../../childProductPriceInterfaces";
import { ChildCoveragesHalfG } from "./ChildCoveragesHalfG";

export const ChildCoverages = (): React.ReactElement => {
  const isChildCoverageExtraHalfGActive = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_2464_ENABLE_NEWCHILD_HALF_G,
  );
  const formProps = useFormikContext<ChildPriceFormValues>();
  const coverages = useCoveragePriceCalculations();

  const { child: productCardTextComponents } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.COVERAGE_CARD,
  );
  const coverageError = getError("coverage", formProps);

  return (
    <>
      {isChildCoverageExtraHalfGActive ? (
        <ChildCoveragesHalfG />
      ) : (
        <>
          {[...coverages]
            .sort(coveragePriceDifference)
            .map(([coverage, priceCalculationEntry]) => (
              <DittoCoverageCard
                key={coverage}
                fieldName="coverage"
                product={ProductBackendName.CHILD}
                coverage={coverage}
                textComponents={productCardTextComponents}
                prices={priceCalculationEntry.prices}
              />
            ))}
        </>
      )}
      {isDefined(coverageError) && (
        <StyledAlert
          fluid
          title={coverageError}
          type="error"
          alertId="childCoverage"
          alertType={AlertType.INPUT_ERROR_ALERT}
        />
      )}
    </>
  );
};
